import React from 'react'
import CustomTemplatesContext from '../../../contexts/CustomTemplatesContext'
import StatusContext from '../../../contexts/StatusContext';
import AuthContext from '../../../contexts/AuthContext';
import { Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom'
import { useEffect } from "react";
import './customtemplates.css'
import { NavBarBuilder } from '../../main/navbarbuilder/NavBarBuilder'
import { ProgressIcon } from '../customicons/ProgressIcon';
import { AlertDialog } from '../alertdialog/AlertDialog'
import Prompts from '../prompts/Prompts'
import {ResponseDisplayTemplates} from "../responsedisplay/ResponseDisplayTemplates"
import Stack from '@mui/material/Stack'
import {PushButton} from '../pushbutton/PushButton'
import {AvailableCredits} from '../availablecredits/AvailableCredits'
import {LoginDialog} from '../logindialog/LoginDialog'
import { DialogNewPrompt } from './DialogNewPrompt';
import { DialogPreview } from './DialogPreview';
import { WaitonResponse } from '../waitonresponse/WaitonResponse';
import AIButton from '../aibutton/AIButton';
import { DialogSelectModels } from '../aibutton/DialogSelectModels';
import { PromptWithIcon } from '../promptwithicon/PromptWithIcon';
import { CustomTooltip } from '../customtooltip/CustomTooltip';
import Checkbox from '@mui/material/Checkbox';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

export const CustomTemplates = () => {

  const mediaQuery = window.matchMedia('(max-width: 500px)');
  const isMobile = mediaQuery.matches;

  

  let {

    prompt,
    displaySample,
    onClearPrompts,
    onClearResponse,
    onSubmit,
    onPreview,
   
    status,
    promptsAvailable,

    changePrompt,
    deletePrompt,
    moveupPrompt,
    movedownPrompt,
    prompts,
    promptareaRef,
    allresponses,
    onAcceptDeleteResponse,
    onCancelDeleteResponse,
    onDeleteResponse,
    changeWho,
    setShowNewPromptDialog,
    setEditMode,
    onEditMode, 
   
    chatPrompt,
    setChatPrompt,
    isDBChecked, 
    setDBCheckBox,
    arrowRight,
    setArrowRight,
    arrowLeft,
    setArrowLeft,
    arrowSplit,
    setArrowSplit,
   
  } = React.useContext(CustomTemplatesContext);

  let {
    scrollRef,
    isLoading,
    changeLanguage,
    openDialog,
    openDialogResponse,
    openDialogBox,
    closeDialogBox,
    openDialogBoxResponse,
    closeDialogBoxResponse,
    setShowLoginDialog,
    getAIModel,
    getAIProvider,
    onClickAIButton,
    isMe,
  } = React.useContext(StatusContext);

  const {
    checkCurrentUser,
} = React.useContext(AuthContext);

  var sample = '';
  const location = useLocation()
  if (location.state !== null)
    sample = location.state.sample

   const handleCheckBox = () => {
    setDBCheckBox(!isDBChecked)
  }

   useEffect(() => {
    //console.log("useEffect: customTemplates")
    const setSample = () => {

      if (sample) {
        displaySample(sample)
        location.state.sample = '';
      }
    }

    setSample();
  
  }, [sample, displaySample, location.state])

  const alertYes = () => {
    console.log("AlertYes")
    onClearPrompts()
    closeDialogBox()
}

const alertCancel = () => {
  console.log("AlertCancel")
  closeDialogBox()
}

const alertYesResponses = () => {
  console.log("AlertYesResponses")
  onClearResponse()
  closeDialogBoxResponse()
}

const alertCancelResponse = () => {
  console.log("AlertCancel")
  closeDialogBoxResponse()
}

  const onNewPrompt = () => {
    if (checkCurrentUser() === false)
      {
        setShowLoginDialog(true)
        return;
      }
    setEditMode(false)
    setShowNewPromptDialog(true)
    
  }

  const handleArrowLeft = () => {
    console.log("OnLeft")
    setArrowRight(false)
    setArrowLeft(true)
    setArrowSplit(false)
  }

  const handleArrowRight = () => {
    console.log("OnRight")
    setArrowLeft(false)
    setArrowRight(true)
     setArrowSplit(false)
  }

  const handleArrowSplit = () => {
    console.log("OnSplit")
    setArrowLeft(false)
    setArrowRight(false)
     setArrowSplit(true)
  }

  return (

    <div className="homeContainer">
      
    <AIButton pane={0} provider = {getAIProvider()} model = {getAIModel()} onClick = {()=>{onClickAIButton(0)}}/>

      <>
        {
          (!isMobile) ?
            <div >
              <NavBarBuilder title={changeLanguage('templates', 'navbartitle')} />
              
                <Row >
                   {
                      !isMobile &&
                      <Stack direction="row" spacing={2}>
                        <>
                          <CustomTooltip title={changeLanguage('templates', 'notes')}>
                            <span><ArrowCircleLeftIcon  className='arrowCircle' disabled={arrowLeft} onClick={handleArrowLeft}/></span>
                          </CustomTooltip>  
                          <CustomTooltip title={changeLanguage('templates', 'responses')}>
                            <span> <ArrowCircleRightIcon  className='arrowCircle' disabled={arrowRight} onClick={handleArrowRight}/></span>
                          </CustomTooltip>
                          <CustomTooltip title={changeLanguage('templates', 'notesandresponses')}>
                            <span><SyncAltIcon className='arrowCircle' disabled={arrowRight} onClick={handleArrowSplit}/></span>
                          </CustomTooltip>
                        </>
                        </Stack>
                    }

                  {
                    (arrowLeft || arrowSplit) &&
                  <Col style={{marginLeft: arrowSplit ? '0%' : '10%', marginRight: arrowSplit ? '0%' : '10%'}}>
                    <label className='labelTitle'>Notes </label>
                    <div className="templatesPromptArea" ref={promptareaRef}>
                      <Prompts prompts={prompts} onDelete={deletePrompt} onChange={changePrompt} onChangeWho = {changeWho} onMoveUp={moveupPrompt} onMoveDown={movedownPrompt} onEdit={onEditMode}/>
                    </div>
                
                  {
                    (promptsAvailable && !arrowSplit) &&
                    <>
                    <br></br>
                      <PromptWithIcon prompt = {chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmit} placeholdertext={changeLanguage('assistant','promptplaceholder')}/>
                    </>
                  }
                    <div  className="mainButtons">
                      <div>
                        <div>
                        <Stack direction="row" spacing={2}>
                          {
                            (promptsAvailable) &&
                            <>
                            <CustomTooltip title={changeLanguage('templates', 'addtooltip')}>
                              <span>
                                <PushButton onClick={onNewPrompt} label =  {changeLanguage('templates','add')}/>
                              </span>
                            </CustomTooltip>
                             </>
                          }
                         
                          {
                            (promptsAvailable) && 
                            <>
                              <CustomTooltip title={changeLanguage('templates', 'previewtooltip')}>
                                <span>
                                <PushButton onClick={onPreview} label =  {changeLanguage('templates','preview')}/> 
                                </span>
                              </CustomTooltip>

                              <PushButton onClick={openDialogBox} label =  {changeLanguage('templates','clearall')}/>
                            </>             
                          }

                      
                          {
                            (!promptsAvailable) &&
                            <>
                            <CustomTooltip title={changeLanguage('templates', 'createtemplatetooltip')}>
                            <span>
                              <PushButton onClick={onNewPrompt} label =  {changeLanguage('templates','createtemplate')}/>
                            </span>
                            </CustomTooltip>
                            </>
                          }

                         </Stack>
                         
                        </div>
                      </div>
                    </div>
                
                      {
                        (promptsAvailable && status) && 
                        <label className='statusLabel'>{status}</label>
                      }
                   
                  </Col>
                  }

                  {
                    (arrowRight || arrowSplit) &&
                  <Col style={{marginLeft: arrowSplit ? '0%' : '10%',marginRight: arrowSplit ? '0%' : '10%'}}>
                
                    <label className='labelTitle'> Responses </label>
                    <div className="templatesPromptArea" ref={scrollRef}>
                      <span style={{ color: 'rgb(199, 178, 178)' }}>{prompt}</span>

                      <div>
                        {
                            Array.isArray(allresponses) &&
                            allresponses.map((item) => (
                                <ResponseDisplayTemplates key= {item.id} displayprompt = {item} 
                                onCancelDelete = {onCancelDeleteResponse} onAcceptDelete= {onAcceptDeleteResponse} onDeletePrompt = {onDeleteResponse}/>
                                ))
                        }
                    </div>

                    {
                      (!status) &&
                        <WaitonResponse />
                    }   

                    </div>
                         
                  {
                      (promptsAvailable && !arrowSplit) &&
                      <>
                        <br></br>
                        <PromptWithIcon prompt = {chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmit} placeholdertext={changeLanguage('assistant','promptplaceholder')}/>
                      </>
                  }   


                    <div className='mainButtons' style = {{marginTop:'-8px'}}>
                      <div>
                        <PushButton onClick={openDialogBoxResponse} label =  {changeLanguage('templates','clearall')}/>
                      </div>

                     <AvailableCredits />
                    </div>
                  </Col>
                  }

                     {
                      (promptsAvailable && arrowSplit) &&
                      <>
                        <br></br>
                        <PromptWithIcon prompt = {chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmit} placeholdertext={changeLanguage('assistant','promptplaceholder')}/>
                      </>
                    }   

                </Row>
            
            </div>

            :

            <div>
              <NavBarBuilder title={changeLanguage('templates', 'navbartitle')} />
              
              <div className="templatesPromptArea" ref={promptareaRef}>
                <Prompts prompts={prompts} onDelete={deletePrompt} onChange={changePrompt} onChangeWho = {changeWho} onMoveUp={moveupPrompt} onMoveDown={movedownPrompt} onEdit={onEditMode}/>
              </div>
                        
              <div className="mainButtons">
                <div>
                  <Stack direction="row" spacing={2}>
                  {
                    (promptsAvailable) && 
                        <>
                        <PushButton onClick={openDialogBox} label =  {changeLanguage('templates','clearall')}/>
                        <PushButton onClick={onPreview} label =  {changeLanguage('templates','preview')}/>
                        </>
                  }

                  {
                    (!promptsAvailable) &&
                      <PushButton onClick={onNewPrompt} label =  {changeLanguage('templates','createtemplate')}/>
                  }

                  {
                    (promptsAvailable) &&
                    <PushButton onClick={onNewPrompt} label =  {changeLanguage('templates','add')}/>
                  }
                

                  </Stack>
                </div>
              </div>

                <div>
                  {
                    (status) && <label className='statusLabel'>{status}</label>
                  }
                </div>
             
                <div className="templatesPromptArea">
                  <span style={{ color: 'rgb(199, 178, 178)' }}>{prompt}</span>

                  <div>
                          {
                              Array.isArray(allresponses) &&
                              allresponses.map((item) => (
                                  <ResponseDisplayTemplates key= {item.id} displayprompt = {item} 
                                  onCancelDelete = {onCancelDeleteResponse} onAcceptDelete= {onAcceptDeleteResponse} onDeletePrompt = {onDeleteResponse}/>
                                  ))
                          }
                  </div>

                  {
                    !status && <WaitonResponse />
                  }
                </div>

              <div className='mainButtons'>
                <div className='flex-container'>
                   
                  <Stack direction="row" spacing={2}>
                  <PushButton onClick={openDialogBoxResponse} label =  {changeLanguage('templates','clearall')}/>

                 
                </Stack>
                </div>

               <AvailableCredits />

              </div>
                {
                  promptsAvailable &&
                  <PromptWithIcon prompt = {chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmit} placeholdertext={changeLanguage('assistant','promptplaceholder')}/>
                }
            </div>
        }
      </>
     
      {
        isMe() &&
          <div>
            <Checkbox
              checked={isDBChecked}
              onChange={handleCheckBox}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 18, color: 'maroon', border: 'none' },    
              }} />
              <label>Use DB</label>
          </div>
      }

      <ProgressIcon isLoading={isLoading} />
      <LoginDialog />
      <DialogSelectModels />
      <DialogNewPrompt />
      <DialogPreview />
      <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={changeLanguage('dialog', 'cleartemplatedata')}/>
      <AlertDialog alertYes={alertYesResponses} alertCancel={alertCancelResponse} openDialog = {openDialogResponse} closeDialog = {closeDialogBoxResponse} prompt={changeLanguage('dialog', 'clearresponse')}/>
    </div>
  )
}

export default CustomTemplates